import {canUseDom} from "../utils/dom"
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import {PAGE_CONTENT_LOADED,
    STATE_PRELOADED,
    TRACK_EVENT,
    FETCH_SEARCH_RESULTS_SUCCESSFUL,
    OPEN_SHOP_THE_LOOK_DIALOG,
    ADD_TO_WISHLIST_SUCCESS, //action.payload.sku
    REMOVE_FROM_WISHLIST_SUCCESS //action.payload.sku
} from '../actions'
import {getPageType, getArticles, getPageId, getIconicUrl} from '../selectors'
import MobileDetect from 'mobile-detect';
import take from 'lodash/take'
import URL from "../utils/URL"
import {BASE_URL} from '../config'

const throttleSendSearchEvent = throttle((action) => {
    if(!action.payload.query || action.payload.query === '' || (action.payload.query.trim && ( action.payload.query.trim() === '' ))) return;
    window.dataLayer.push({
        event: 'ed.search',
        category: 'search',
        action: `word typed - ${action.payload.query.toLowerCase()}`,
        label: action.payload.total_results_size === 0 ?
            "no results found" : ""
    });
}, 5000, {leading: false, trailing: true});

const onPageChanged = (state) => {
    window.dataLayer.push(
        {
            hitType: 'pageview',
            event: 'pageview', // this is done automatically
            page: window.location.pathname + window.location.search,
            '2-digit_iso_country_code': 'AU',
            article_type: get( state, ['content', 'page', 'category']),
            article_categories: get( state, ['content', 'page', 'tags']),
        });

    var md = new MobileDetect(window.navigator.userAgent);
    var device = md.phone() ? 'm' : md.tablet() ? 't' : 'd';
    var pageType = getPageType(state);
    if(pageType === 'today_landing_page' || pageType === 'landing_page' ||
        pageType === 'lookbooks_landing_page')
    {
        var articles = getArticles(state);
        window.dataLayer.push(
            {
                event: 'ed.category_page',
                DeviceType: device,
                ListArticles: take(articles, 3).map(x => x.id)
            });
    }

    if(pageType === 'article' || pageType === 'lookbook') {
        window.dataLayer.push(
            {
                event: 'ed.article_page',
                DeviceType: device,
                ArticleId: getPageId(state),
            });
    }
}

const isExternalUrl = (url) => {
    if(url.startsWith(BASE_URL)) return false;
    const targetUrl = new URL(url);
    return ! targetUrl.pathname.startsWith(BASE_URL);
}

const isExternalUrlToIconic = (iconicUrl, url) => {
    const iconic = new URL(iconicUrl);
    const iconicMainSite = new URL('https://www.theiconic.com.au');
    const target = new URL(url);
    return target.host === iconic.host ||
        target.host === iconicMainSite.host;
}

const onExternalLinkClicked = (state) => {
    var md = new MobileDetect(window.navigator.userAgent);
    var device = md.phone() ? 'm' : md.tablet() ? 't' : 'd';
    window.dataLayer.push({
        event: 'ed.external_link_main_website',
        TransactionId: new Date().getTime(),
        DeviceType: device,
        ArticleId: getPageId(state),
    })
}

const googleTagManager = store => next => action => {
    next(action)

    if ( ! canUseDom || ! window.dataLayer ) return;

    switch(action.type) {
        case PAGE_CONTENT_LOADED:
        case STATE_PRELOADED:
            onPageChanged(store.getState());
            break;
        case TRACK_EVENT:
            const {url, tracking} = action.payload;
            if( tracking && tracking.category && tracking.action ) {
                window.dataLayer.push({
                    ...tracking,
                    event: tracking.event ? tracking.event.toLowerCase() : tracking.category ? tracking.category.toLowerCase() : ''
                });
            }

            if(isExternalUrl(url) &&
                isExternalUrlToIconic(getIconicUrl(store.getState()), url))
            {
                onExternalLinkClicked(store.getState());
            }

            break;
        case FETCH_SEARCH_RESULTS_SUCCESSFUL:
            throttleSendSearchEvent(action);
            break;
        case OPEN_SHOP_THE_LOOK_DIALOG:

            window.dataLayer.push({
                category: 'shop the look',
                event: 'ed.shop_the_look.open',
                action: `click - ${get(store.getState(), ['content', 'page', 'title'])}`.toLowerCase(),
            });

            break;
        case ADD_TO_WISHLIST_SUCCESS:
            window.dataLayer.push({
                category: 'Shop the look - Edition',
                event: 'ed.product.add-to-wishlist',
                action: 'Add to Wishlist',
                label: action.payload.sku
            });
            break;
        case REMOVE_FROM_WISHLIST_SUCCESS:
            window.dataLayer.push({
                category: 'Shop the look - Edition',
                event: 'ed.product.remove-to-wishlist',
                action: 'Remove from Wishlist',
                label: action.payload.sku
            });
            break;
        // no default
    }
}

export default googleTagManager;



// WEBPACK FOOTER //
// ./src/middleware/googleTagManager.js